import type { UniDriver } from '@wix/unidriver-core';
import { numberInputDriverFactory as publicDriverFactory } from './NumberInput.uni.driver';

export const numberInputDriverFactory = (base: UniDriver, body: UniDriver) => {
  return {
    ...publicDriverFactory(base, body),

    // Add here driver methods that considered "private"
  };
};
